import { render, staticRenderFns } from "./Professions.vue?vue&type=template&id=21f3ea4f&scoped=true&"
import script from "./Professions.vue?vue&type=script&lang=js&"
export * from "./Professions.vue?vue&type=script&lang=js&"
import style0 from "./Professions.vue?vue&type=style&index=0&id=21f3ea4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3ea4f",
  null
  
)

export default component.exports